import { Component } from 'react';
export default class ColumnGroup extends Component {
}
ColumnGroup.__C7N_TABLE_COLUMN_GROUP = true;
